export const ROUTES = {
  HOME: '/',
  PRIVACY_POLICY: '/privacy-policy',
  TERM_CONDITIONS: '/terms-conditions'
};
